import { BalanceSheetService } from '@services/balance-sheet/balance-sheet.service';
import { PermissionsService } from '@services/auth/permissions.service';
import { Injectable } from '@angular/core';
import { TrackingService } from './tracking.service';
import { TableSetupService } from '@services/lookup-tables/table-setup.service';
import { forkJoin } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GlobalSaveService {
  constructor(
    private tracking: TrackingService,
    private lookupDataSetupService: TableSetupService,
    private permissionsService: PermissionsService,
    private balanceSheetService: BalanceSheetService
  ) {}

  public initialDBCallsToCheckSaveButton() {
    const sources = {} as any;
    if (this.permissionsService.getPermission('ModelDataLiquiditySourcesEquations') === 'W') {
      sources.liq = this.tracking.getUserEditTrackingTable('LiquiditySourcesPeriodEquations');
    }
    if (this.permissionsService.getPermission('ModelDataExogenousLinesEquations') === 'W') {
      sources.exo = this.tracking.getUserEditTrackingTable('ExogenousLinesPeriodEquations');
    }
    if (this.permissionsService.getPermission('ModelDataAuxiliaryAccountsEquations') === 'W') {
      sources.aux = this.tracking.getUserEditTrackingTable('AuxiliaryAccountsPeriodEquations');
    }
    if (this.permissionsService.getPermission('ModelDataLookuptables') === 'W') {
      sources.lut = this.lookupDataSetupService.getLookupTablesWithData().toPromise();
    }
    if (this.permissionsService.getPermission('RunSimulation') === 'W') {
      sources.sim = this.tracking.checkTempResults().toPromise();
    }
    if (this.permissionsService.getPermission('ModelStructureBalanceSheet') === 'W') {
      sources.bal = this.balanceSheetService.getBalanceSheets();
    }
    forkJoin(sources).subscribe();
  }
}
